import React from 'react';
import PageHeader from '../components/PageHeader';
import CTASection from '../components/CTASection';
import FamilyGallery from '../components/FamilyGallery';
import Reveal from '../components/Reveal';

const PUB = process.env.PUBLIC_URL;

const gallery = [
  {
    src: `${PUB}/media/family/lax-dreams.jpg`,
    alt: 'Ron and Danielle with the boys at a youth lacrosse tournament',
    caption: 'Where it started — youth lacrosse weekends.',
  },
  {
    src: `${PUB}/media/family/lacrosse-32.jpg`,
    alt: 'Ron and Danielle with their son in a Horseheads lacrosse uniform',
    caption: 'Horseheads lacrosse, game day.',
  },
  {
    src: `${PUB}/media/family/geneseo-31.jpg`,
    alt: 'The Johanson family at a SUNY Geneseo lacrosse game',
    caption: 'College lacrosse at SUNY Geneseo.',
  },
  {
    src: `${PUB}/media/family/senior-night.jpg`,
    alt: 'The Johanson family together on lacrosse senior night',
    caption: 'Senior night, under the lights.',
    wide: true,
  },
  {
    src: `${PUB}/media/family/geneseo-22.jpg`,
    alt: 'Ron and Danielle with their son after a Geneseo game',
    caption: 'Always there for the boys.',
  },
  {
    src: `${PUB}/media/family/motocross-mud.jpg`,
    alt: 'Danielle with their son after a muddy motocross race',
    caption: 'Race day in the mud.',
  },
  {
    src: `${PUB}/media/family/motocross-track.jpg`,
    alt: 'Ron and his son trackside at a motocross event',
    caption: 'Trackside, together.',
  },
  {
    src: `${PUB}/media/family/night-game.jpg`,
    alt: 'The Johanson family at a Friday night game',
    caption: 'Friday nights, all in.',
  },
];

function FamilyPage() {
  return (
    <>
      <PageHeader
        eyebrow="Family"
        title="Built on the People I Come Home To"
        lead="Three decades of marriage, three sons, and a deep love for the place that raised him."
      />

      <section className="section">
        <div className="container">
          <Reveal as="blockquote" variant="right" className="family__quote">
            Big Flats represents a great way to raise a family. The schools
            are solid. Crime is very low. And we&rsquo;re in an area
            that&rsquo;s growing.
            <cite>&mdash; Ron Johanson</cite>
          </Reveal>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <Reveal>
            <div className="section__eyebrow">Off the Clock</div>
            <h2 className="section__title">Sidelines, Tracks &amp; Game Days</h2>
            <p className="section__lead">
              From youth lacrosse tournaments to college sidelines and muddy
              motocross weekends, the Johansons show up for each other.
            </p>
          </Reveal>
          <FamilyGallery items={gallery} />
        </div>
      </section>

      <section className="section">
        <div className="container">
          <Reveal>
            <h2 className="section__title">Three Sons. Three Entrepreneurs.</h2>
          </Reveal>
          <div className="sons__grid">
            <Reveal as="div" className="son-card" delay={0}>
              <h3>Alexander</h3>
              <div className="son-card__meta">Business student &middot; SUNY Geneseo</div>
              <p>
                A fourth-year business student interning with Excellus Blue
                Cross Blue Shield. Runs a firewood business on the family
                property, turning dead ash trees into something useful.
              </p>
            </Reveal>
            <Reveal as="div" className="son-card" delay={90}>
              <h3>Niklas</h3>
              <div className="son-card__meta">Criminal Justice &middot; Mansfield University</div>
              <p>
                Second-year student who came to his dad and said, &ldquo;I
                gotta make some money.&rdquo; Started his own driveway sealing
                and snow plowing business and has never looked back.
              </p>
            </Reveal>
            <Reveal as="div" className="son-card" delay={180}>
              <h3>Owen</h3>
              <div className="son-card__meta">Senior &middot; Horseheads High School</div>
              <p>
                The youngest of the three. Mows lawns, takes on contracting
                jobs on the side, and is looking at colleges &mdash;
                considering a career as a state trooper.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}

export default FamilyPage;
